import ClientsPage from './views/clients.page';
import EditClient from './views/editClient';

export default {
  views: {
    ClientsPage,
    EditClient,
  },
};
